import React from "react"
import "react-responsive-tabs/styles.css"
import ExploreCategoryToggle from "../explore/ExploreCategoryToggle"
import Portfolio from "./portfolio"
import CareerPlans from "../careers/career-plans"
import AssessmentOverview from "../assessment/assessment-overview-content"
import { FormattedMessage } from "react-intl"
import WorkReadiness from "../curriculum/WorkReadinessTab"
import GoalTrackingTab from "./goals/GoalTrackingTab"

const DashboardTabContent = [
  {
    name: <a href={void 0}><FormattedMessage
      id="dashboard-tab-explore"
      defaultMessage="Explore"
    /></a>,
    param: "explore",
    content: <ExploreCategoryToggle heading={<FormattedMessage id="dashboard-tab-explore" defaultMessage="Explore" />} />,
  },
  {
    name: <a href={void 0}><FormattedMessage
      id="dashboard-tab-assessment"
      defaultMessage="Assessment"
    /></a>,
    param: "assessment",
    content: <AssessmentOverview />,
  },
  {
    name: <a href={void 0}><FormattedMessage
      id="dashboard-tab-portfolio"
      defaultMessage="Portfolio"
    /></a>,
    param: "portfolio",
    content: <Portfolio />,
    containerClassName: "",
  },
  {
    name: <a href={void 0}><FormattedMessage
      id="dashboard-tab-career-plans"
      defaultMessage="Career Plans"
    /></a>,
    param: "career-plan",
    content: <CareerPlans />,
  },
  {
    name: <a href={void 0}><FormattedMessage id="dashboard-tab-work-readiness" defaultMessage="Work Readiness" /></a>,
    param: "work-readiness",
    content: <WorkReadiness />,
  },
  {
    name: <a href={void 0}><FormattedMessage id="dashboard-tab-goal-tracking" defaultMessage="Goal Tracking" /></a>,
    param: "goal-tracking",
    content: <GoalTrackingTab />,
  },
]

export default DashboardTabContent
